import { useMutation, useQuery, useQueryClient } from 'react-query'
import { FinancialAssistanceApi } from 'src/api/client'
import {
  FETCH_FINANCIAL_ASSISTANCE_PROGRAMS,
  FETCH_PROGRAM,
  FETCH_PROGRAM_FINANCIAL_ASSISTANCE_PROGRAMS
} from 'src/constants/queries'
import {
  IFinancialAssistanceProgram,
  IProgramFinancialAssistancePrograms
} from 'src/models/financialAssistance'

export const useFinancialAssistancePrograms = () => {
  const query = useQuery<{ programs: IFinancialAssistanceProgram[] }>({
    queryKey: FETCH_FINANCIAL_ASSISTANCE_PROGRAMS,
    queryFn: () => FinancialAssistanceApi.getFinancialAssistancePrograms()
  })

  return { ...query, programs: query.data ? query.data.programs : [] }
}

export const useProgramFinancialAssistancePrograms = (programId: string) => {
  return useQuery<IProgramFinancialAssistancePrograms>({
    queryKey: FETCH_PROGRAM_FINANCIAL_ASSISTANCE_PROGRAMS(programId),
    queryFn: () =>
      FinancialAssistanceApi.getProgramFinancialAssistancePrograms(programId),
    enabled: !!programId
  })
}

export const useUpdateProgramFinancialAssistancePrograms = (
  programId: string,
  {
    onSuccess,
    onError
  }: {
    onSuccess?: () => void
    onError?: (err: unknown) => void
  } = {}
) => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    (financialAssistancePrograms: string[]) =>
      FinancialAssistanceApi.updateProgramFinancialAssistancePrograms(
        programId,
        { financialAssistancePrograms }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          FETCH_PROGRAM_FINANCIAL_ASSISTANCE_PROGRAMS(programId)
        )
        queryClient.invalidateQueries(FETCH_PROGRAM(programId))
        if (onSuccess) onSuccess()
      },
      onError: (err) => {
        if (onError) onError(err)
      }
    }
  )

  return {
    ...mutation,
    updateProgramFinancialAssistancePrograms: mutation.mutateAsync
  }
}
